import { render, staticRenderFns } from "./Resultat.vue?vue&type=template&id=24d1d899&"
import script from "./Resultat.vue?vue&type=script&lang=js&"
export * from "./Resultat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports